
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms-of-service-main",
      function () {
        return require("private-next-pages/terms-of-service-main.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms-of-service-main"])
      });
    }
  